<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M2.25,20.25C1.009,20.25,0,19.241,0,18v-3c0-0.414,0.336-0.75,0.75-0.75C1.991,14.25,3,13.241,3,12
		c0-1.241-1.009-2.25-2.25-2.25C0.336,9.75,0,9.414,0,9V6c0-1.241,1.009-2.25,2.25-2.25h19.5C22.991,3.75,24,4.759,24,6v3
		c0,0.414-0.336,0.75-0.75,0.75C22.009,9.75,21,10.759,21,12c0,1.241,1.009,2.25,2.25,2.25c0.414,0,0.75,0.336,0.75,0.75v3
		c0,1.241-1.009,2.25-2.25,2.25H2.25z M1.5,18c0,0.414,0.336,0.75,0.75,0.75h19.5c0.414,0,0.75-0.336,0.75-0.75v-2.325
		c-1.732-0.35-3-1.875-3-3.675s1.268-3.324,3-3.675V6c0-0.414-0.336-0.75-0.75-0.75H2.25C1.836,5.25,1.5,5.586,1.5,6v2.325
		c1.732,0.35,3,1.875,3,3.675s-1.268,3.324-3,3.675V18z"/>
	<path d="M8.25,11.25C7.009,11.25,6,10.241,6,9s1.009-2.25,2.25-2.25S10.5,7.759,10.5,9S9.491,11.25,8.25,11.25z M8.25,8.25
		C7.836,8.25,7.5,8.586,7.5,9s0.336,0.75,0.75,0.75S9,9.414,9,9S8.664,8.25,8.25,8.25z"/>
	<path d="M16.5,17.25c-1.241,0-2.25-1.009-2.25-2.25s1.009-2.25,2.25-2.25s2.25,1.009,2.25,2.25S17.741,17.25,16.5,17.25z
		 M16.5,14.25c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75S16.914,14.25,16.5,14.25z"/>
	<path d="M8.25,16.5c-0.2,0-0.389-0.078-0.53-0.22c-0.292-0.292-0.292-0.768,0-1.061l7.5-7.5c0.142-0.142,0.33-0.22,0.53-0.22
		s0.389,0.078,0.53,0.22c0.142,0.141,0.22,0.33,0.22,0.53s-0.078,0.389-0.22,0.53l-7.5,7.5C8.639,16.422,8.45,16.5,8.25,16.5z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'discount-coupon',
    },
    name: {
      type: String,
      required: false,
      default: 'DiscountCoupon',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>